import React from 'react';
import { Link } from 'react-router';
import styles from './styles.scss';

function ProductVariant({
  image,
  title,
  cost,
  details,
  query,
  color
}) {
  return (
    <div className={`${styles.sameHeight} col-sm-4`}>
      <div className={styles.container}>
        <img src={image} alt="title" className={styles.image} />
        <div className={`${styles.title} bold`}>
          {title}
        </div>
        <div className={`${styles.details} light`}>
          {details}
        </div>
        <div className={styles.bottom}>
          <div style={{color}} className={`${styles.cost} bold`}>
            {cost}
          </div>
          <Link to={{ pathname: '/get-started', query }} className="btn btn-dc-primary btn-block">
            START
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ProductVariant;



// WEBPACK FOOTER //
// ./src/components/ProductVariant/index.js